import { styled } from '@mui/material';
import Box from '@mui/material/Box';

const BankDetailsModuleStyledContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const BankDetailsItemStyledContainer = styled(Box)`
  .digital-codes-wrapper {
    display: flex;
    position: relative;
    gap: 20px;
  }

  .card {
    display: flex;
    position: relative;
    gap: 20px;
    flex-direction: column;
  }

  .module-title {
    color: #3460b4;
    font-weight: 500;
    font-size: 16px;
  }

  .module-control-wrapper {
    display: flex;
    justify-content: space-between;

    &__buttons {
      display: flex;
      gap: 5px;
    }

    .checkbox-label {
      color: #000000;
      font-size: 14px;
    }
  }

  .currency-account-wrapper {
    display: flex;
    position: relative;
    gap: 20px;

    &__main {
      width: 50%;
    }

    &__secondary {
      width: 50%;
    }
  }

  .bank-data-wrapper {
    display: flex;
    position: relative;
    gap: 20px;

    &__item {
      width: 30%;

      &-bik {
        width: 40%;
      }
    }
  }

  .currency {
    legend {
      font-size: 0.85em !important;
    }
  }
`;

export { BankDetailsItemStyledContainer, BankDetailsModuleStyledContainer };
